import {useRef,useState} from 'react';
import type {CallReply} from './types';

export function useGuestCallLink(request:(event:string,payload:unknown)=>Promise<CallReply>,origin:string) {
  const [open,setOpen]=useState(false),[busy,setBusy]=useState(false);
  const [reply,setReply]=useState<CallReply>(),[notice,setNotice]=useState('');
  const pending=useRef(false);
  const create=async()=>{
    if(pending.current)return;
    pending.current=true;setBusy(true);setOpen(true);setReply(undefined);setNotice('');
    try {
      const result=await request('call_guest_link',{standalone:true,action:'get'});
      if(!result.invitation)throw new Error('Не удалось создать приглашение. Попробуйте ещё раз.');
      setReply(result);
      try {
        await navigator.clipboard.writeText(`${origin}/call/#${result.invitation.token}`);
        setNotice('Ссылка скопирована. Вставьте её в сообщение в любом мессенджере.');
      } catch {setNotice('Автоматическое копирование недоступно. Нажмите «Скопировать» или скопируйте ссылку из поля.');}
    } catch(error){setNotice(error instanceof Error?error.message:'Не удалось создать ссылку.');}
    finally{pending.current=false;setBusy(false);}
  };
  return {open,busy,reply,notice,create,close:()=>setOpen(false)};
}
